import { useNavigate, useLocation } from 'react-router-dom';
import { useMemo } from 'react';

/**
 * Hook to create history and location objects for use-query-params v1.
 * This version of use-query-params expects history and location props directly.
 */
export const useReactRouter6Adapter = () => {
  const navigate = useNavigate();
  const routerLocation = useLocation();

  // Create a location object compatible with use-query-params
  const location = useMemo(
    () => ({
      ...routerLocation,
      search: routerLocation.search || window.location.search,
    }),
    [routerLocation]
  );

  const history = useMemo(
    () => ({
      push: ({ search }: { search?: string }) => {
        navigate(
          { pathname: routerLocation.pathname, search },
          { replace: false }
        );
      },
      replace: ({ search }: { search?: string }) => {
        navigate(
          { pathname: routerLocation.pathname, search },
          { replace: true }
        );
      },
    }),
    [navigate, routerLocation.pathname]
  );

  return { history, location };
};
